module.exports = __webpack_public_path__ + "public/img/12.1b420f50.png";